import { render, staticRenderFns } from "./CustomerRegistered.vue?vue&type=template&id=46466acc"
import script from "./CustomerRegistered.vue?vue&type=script&lang=js"
export * from "./CustomerRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports